import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import { palette } from 'theme/palette';
import { setShownPage } from 'reducers/shownPageReducer';
import { selectPartnerId } from 'selectors/partnerStatusSelector';
import { setSelectedProduct } from 'reducers/tableReducer';
import { useNavigate } from 'react-router';
import { AppDispatch } from 'store';
import { videoIdentificationStyles } from './VideoIdentificationFormActions';

export const VideoIdentificationDetailsActions = () => {
  const dispatch = useDispatch<AppDispatch>();
  const partnerId = useSelector(selectPartnerId);
  const navigate = useNavigate();

  const handleCancel = () => {
    dispatch(setShownPage(''));
    dispatch(setSelectedProduct(undefined));
    navigate(`/partner?partnerNumber=${partnerId}`);
  };

  return (
    <Box data-testid="video-identification-details-actions" sx={videoIdentificationStyles.actions}>
      <Button
        id="cancel-video-identification-details-button"
        data-testid="cancel-video-identification-details-button"
        onClick={handleCancel}
        variant="outlined"
        style={{ color: palette.black }}
      >
        Cancel
      </Button>
    </Box>
  );
};
